<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/cms/widgets'">Widgets</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      <span class="fs-5 fw-bold mb-0">Edit Widget</span>
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3 mb-3">
          <div class="col">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi bi-tag"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>
          <div class="col">
            <label for="site" class="form-label">Site</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="site" class="form-select" formControlName="siteId">
                <option [ngValue]="null" disabled>Select site</option>
                @for (site of sites; track site) {
                  <option [ngValue]="site.id">{{ site }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label for="productPriority" class="form-label">Arbitrage</label>
            <app-product-priority-selector id="productPriority" formControlName="productPriority" [selectMode]="true" [lang]="widget?.site?.lang ?? null"></app-product-priority-selector>
          </div>
          <div class="col">
            <label for="site" class="form-label">Access rights</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <select id="site" class="form-select" formControlName="scope">
                <option value="public">Public</option>
                <option value="private">Private</option>
                <option value="protected">Protected</option>
              </select>
            </div>
          </div>
<!--          <div class="col">-->
<!--            <label for="transDefaultDomain" class="form-label">Translation domain</label>-->
<!--            <div class="input-group">-->
<!--              <span class="input-group-text"><i class="bi bi-translate"></i></span>-->
<!--              <select id="transDefaultDomain" class="form-select" formControlName="transDefaultDomainId">-->
<!--                <option [ngValue]="null">None</option>-->
<!--                @for (domain of translationDomains; track domain.id) {-->
<!--                  <option [ngValue]="domain.id">{{ domain.domain }}</option>-->
<!--                }-->
<!--              </select>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="row mt-5">
          <div class="col-6">
            <div
              class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-2">
              <h3 class="fw-bold fs-6 mb-0">Widget</h3>
              <i class="bi bi-filetype-html text-primary me-2"></i>
            </div>
            <app-widget-viewer [widget]="widget" [theme]="theme"></app-widget-viewer>
          </div>
          <div class="col-6">
            <div
              class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-2">
              <h3 class="fw-bold fs-6 mb-0">Theme</h3>
              <i class="bi bi-css text-primary me-2"></i>
            </div>
            <app-theme-selector [schema]="themeSchema" [theme]="theme"></app-theme-selector>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col">
            <div class="row">
              <div class="col"></div>
              <div class="col-auto">
                <app-input-switch id="enabled" formControlName="enabled">Enabled</app-input-switch>
              </div>
            </div>
          </div>
          <div class="col-auto text-end">
            <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
              <span>Update</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
